module.exports = __webpack_public_path__ + "static/media/expand-arrows-alt.91a38bcc.svg";